import { keyframes } from 'styled-components';

export const SIDE_SHEET_WIDTHS = {
  STANDARD: '296px',
};

export const overlayKeyframeIn = keyframes`
  0% {
    opacity: 0;
    z-index: ${({ theme }) => theme.zIndex.hidden.value};
  }

  1% {
    opacity: 0;
    z-index: ${({ theme }) => theme.zIndex.sideSheetOverlay.value};
  }

  100% {
    opacity: 1;
    z-index: ${({ theme }) => theme.zIndex.sideSheetOverlay.value};
  }
`;

export const overlayKeyframeOut = keyframes`
  0% {
    opacity: 1;
    z-index: ${({ theme }) => theme.zIndex.sideSheetOverlay.value};
  }

  99% {
    opacity: 0;
    z-index: ${({ theme }) => theme.zIndex.sideSheetOverlay.value};
  }

  100% {
    opacity: 0;
    z-index: ${({ theme }) => theme.zIndex.hidden.value};
  }
`;
